import { render, staticRenderFns } from "./FinancialTipsArticle1.vue?vue&type=template&id=4d145590&scoped=true"
import script from "./FinancialTipsArticle1.vue?vue&type=script&lang=js"
export * from "./FinancialTipsArticle1.vue?vue&type=script&lang=js"
import style0 from "./FinancialTipsArticle1.vue?vue&type=style&index=0&id=4d145590&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d145590",
  null
  
)

export default component.exports